import React from "react";
import { Card, Divider, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import PreviewBulkScanGsm from "../../../components/Comman/BulkInwardOutward/PreviewBulkScanGsm";
import BinLocationService from "../../../services/Wash-service/BinLocationService";
import "../../../styles/global-ui.css";

const Gsm_BulkInwardPreviewPage = () => {
  const navigate = useNavigate();

  const handleConfirmBinInward = async (formatedBinId, addedBy) => {
    try {
      const response = await BinLocationService.garment_supermarket_bulk_inward(
        formatedBinId,
        addedBy
      );

      console.log("Response:", response);
      return response;
    } catch (error) {
      console.error("Error during bin movement:", error);
      throw error;
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            <span className="page-title-inline">
              <ArrowLeftOutlined
                className="page-back-icon"
                onClick={() => navigate(-1)}
              />
              GSM Bin Inward Preview
            </span>
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Review selected bins before confirming inward to garment supermarket
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <PreviewBulkScanGsm
          handleConfirmBinInward={handleConfirmBinInward}
          title="GSM Bin Inward Preview"
          type="inward"
        />
      </Card>
    </div>
  );
};

export default Gsm_BulkInwardPreviewPage;